"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../../elements/button/Button");
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _scrollTo = require("../../utils/scroll/scrollTo");
var _errorCodeConstants = _interopRequireDefault(require("../../constants/errorCodeConstants"));
var _messageModule = _interopRequireDefault(require("./message.module.scss"));
var _TickInCircle32PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/TickInCircle32PxOutlined"));
var _Warning32PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/Warning32PxOutlined"));
var _Info32PxOutlined = _interopRequireDefault(require("../../elements/icons-jb/Info32PxOutlined"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bodyText = function bodyText(body, isOldMessage, styles) {
  var isNode = /*#__PURE__*/_react["default"].isValidElement(body);
  if (isNode) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-test": isOldMessage ? undefined : 'message-body',
      className: styles['c-message__body'],
      children: body
    });
  }
  if (body) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      "data-test": isOldMessage ? undefined : 'message-body',
      className: styles['c-message__body'],
      children: body
    });
  }
  return null;
};
var displayIcon = function displayIcon(type) {
  switch (type) {
    case 'error':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Warning32PxOutlined["default"], {});
    case 'success':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TickInCircle32PxOutlined["default"], {});
    case 'warning':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Info32PxOutlined["default"], {});
    case 'info':
    case 'infoInline':
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Info32PxOutlined["default"], {});
  }
};
var typeStyle = function typeStyle(type) {
  switch (type) {
    case 'error':
    case 'info':
    case 'warning':
    case 'infoInline':
      return "c-message__inner--".concat(type);
    default:
      return 'c-message__inner--info';
  }
};
var Button = function Button(_ref) {
  var buttonLevel = _ref.buttonLevel,
    onClick = _ref.onClick,
    dataTest = _ref.dataTest,
    children = _ref.children;
  var classes = (0, _classnames["default"])(_messageModule["default"]['c-message__button'], _messageModule["default"]["c-message__button--".concat(buttonLevel)]);
  var buttons = {
    primary: _Button.PrimaryButton,
    secondary: _Button.SecondaryButton,
    underlined: _Button.UnderlinedButton,
    tertiary: _Button.TertiaryButton
  };
  var ButtonWithLevel = buttons[buttonLevel] || buttons['underlined'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonWithLevel, {
    onClick: onClick,
    "data-test": dataTest,
    className: classes,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: children
    })
  });
};
var Message = /*#__PURE__*/function (_Component) {
  _inherits(Message, _Component);
  function Message(props) {
    var _this;
    _classCallCheck(this, Message);
    _this = _callSuper(this, Message, [props]);
    _this.state = {
      refreshesArray: [0]
    };
    return _this;
  }
  _createClass(Message, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        type = _this$props.type,
        disableScrollToOnMount = _this$props.disableScrollToOnMount,
        focusOnAlert = _this$props.focusOnAlert,
        code = _this$props.code;
      if (!disableScrollToOnMount && type !== 'info') {
        (0, _scrollTo.scrollToElement)("[data-error=\"".concat(code, "\"]"), focusOnAlert);
      }
    }

    // https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/230
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.refreshes !== nextProps.refreshes) {
        var arr = this.state.refreshesArray;
        this.setState({
          refreshesArray: arr.concat(nextProps.refreshes)
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        type = _this$props2.type,
        focusOnAlert = _this$props2.focusOnAlert,
        code = _this$props2.code,
        disableScrollToOnUpdate = _this$props2.disableScrollToOnUpdate,
        refreshes = _this$props2.refreshes;
      var hasRefreshesChanged = prevProps.refreshes < refreshes;
      if (!disableScrollToOnUpdate && type !== 'info' && hasRefreshesChanged) {
        (0, _scrollTo.scrollToElement)("[data-error=\"".concat(code, "\"]"), focusOnAlert);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        type = _this$props3.type,
        title = _this$props3.title,
        body = _this$props3.body,
        buttonText = _this$props3.buttonText,
        buttonLevel = _this$props3.buttonLevel,
        onButtonClick = _this$props3.onButtonClick,
        code = _this$props3.code,
        animation = _this$props3.animation,
        dataTest = _this$props3['data-test'],
        className = _this$props3.className,
        id = _this$props3.id,
        formInline = _this$props3.formInline;
      var refreshesArray = this.state.refreshesArray;
      var validationError = code === _errorCodeConstants["default"].CLIENT_FORM_VALIDATION_ERRORS;
      var containerClassName = (0, _classnames["default"])(_messageModule["default"]['c-message'], _defineProperty(_defineProperty(_defineProperty({}, _messageModule["default"]['c-message--inline'], type.toLowerCase().indexOf('inline') !== -1), className, !!className), _messageModule["default"]['c-message--form-inline'], formInline));
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: id,
        className: containerClassName,
        children: refreshesArray.map(function (val, index, arr) {
          var isOldMessage = arr.length > 1 && index !== arr.length - 1;
          var props = isOldMessage ? {
            'aria-hidden': true,
            style: {
              display: 'none'
            },
            className: (0, _classnames["default"])(_messageModule["default"]['c-message__inner'], _messageModule["default"][typeStyle(type)])
          } : {
            role: 'alert',
            'data-test': dataTest,
            'data-error': code,
            tabIndex: '-1',
            className: (0, _classnames["default"])(_messageModule["default"]['c-message__inner'], _messageModule["default"][typeStyle(type)], _defineProperty({}, _messageModule["default"]['c-message__horizontalShake'], animation === 'shake'))
          };
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: _messageModule["default"]['c-message__copy-container'],
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: (0, _classnames["default"])(_messageModule["default"]['c-message__icon'], _messageModule["default"]['joyfully-bold']),
                children: displayIcon(type)
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
                className: (0, _classnames["default"])(_messageModule["default"]['c-message__title'], _messageModule["default"]['joyfully-bold'], {
                  sessioncamlogerror: type === 'error' && !validationError
                }),
                "data-test": isOldMessage ? undefined : "".concat(dataTest, "-title"),
                children: title
              }), bodyText(body, isOldMessage, _messageModule["default"]), buttonText && /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
                buttonLevel: buttonLevel,
                onClick: onButtonClick,
                dataTest: isOldMessage ? undefined : 'message-button',
                children: buttonText
              })]
            })
          }), "message-".concat(val));
        })
      });
    }
  }]);
  return Message;
}(_react.Component);
_defineProperty(Message, "propTypes", {
  /** One of: info, success, error */
  type: _propTypes["default"].string,
  /** Optional error code to show in data-error attribute */
  code: _propTypes["default"].string,
  /** Top-line title for the message */
  title: _staticContentPropCheck["default"].isRequired,
  /** String (or markup) for the body of the message */
  body: _staticContentPropCheck["default"],
  /** Custom class name to be added */
  className: _propTypes["default"].string,
  /** Display a button after the message body with this label */
  buttonText: _staticContentPropCheck["default"],
  /** Display a button after the message body with this style */
  buttonLevel: _propTypes["default"].string,
  /** Display a button after the message body with this action */
  onButtonClick: _propTypes["default"].func,
  /**  */
  refreshes: _propTypes["default"].number,
  /** Option to animate message; only 'shake' supported */
  animation: _propTypes["default"].string,
  /** Capture the browser's focus */
  focusOnAlert: _propTypes["default"].bool,
  /** Do not scroll to message when it is mounted */
  disableScrollToOnMount: _propTypes["default"].bool,
  /** Do not scroll to message when it is updated */
  disableScrollToOnUpdate: _propTypes["default"].bool,
  /** Set an option data-test attribute */
  'data-test': _propTypes["default"].string,
  /** Optional ID attribute for the message container */
  id: _propTypes["default"].string
});
_defineProperty(Message, "defaultProps", {
  type: 'info',
  body: '',
  code: '',
  buttonText: '',
  buttonLevel: 'underlined',
  className: '',
  onButtonClick: function onButtonClick() {},
  refreshes: 0,
  animation: '',
  focusOnAlert: false,
  disableScrollToOnMount: false,
  disableScrollToOnUpdate: false,
  'data-test': 'message',
  id: undefined
});
var _default = exports["default"] = Message;